import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LatestFeed from "./components/LatestFeed";
import Timeline from "./components/Timeline";
import Guide from "./components/Guide";
import Channels from "./components/Channels";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <LatestFeed />
        <Timeline />
        <Guide />
        <Channels />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />

      {showTop && (
        <a
          href="#top"
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-background-50 shadow-none transition-colors hover:bg-primary-700"
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
        </a>
      )}
    </div>
  );
}